import React from 'react';
import { View, type StyleProp, type ViewStyle } from 'react-native';

/**
 * The web build's gradient: react-native-web passes backgroundImage through to the DOM, so the
 * browser draws the real gradient; the first colour is the fallback.
 */
export function Gradient({ colors, style, children, testID }: {
  colors: string[];
  style?: StyleProp<ViewStyle>;
  children?: React.ReactNode;
  testID?: string;
}) {
  const web: any = { backgroundColor: colors[0], backgroundImage: `linear-gradient(135deg, ${colors.join(', ')})` };
  return <View style={[web, style]} testID={testID}>{children}</View>;
}
